import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import ActionModalHeader, { DemoNote, customerName } from "./ActionModalHeader";

// STATIC DESIGN — wallet adjustment for customers without a credit line
// (credit-line customers use the real ManageCreditsModal instead)
interface AdjustWalletModalProps { show: boolean; onHide: () => void; user: any }

const AdjustWalletModal = ({ show, onHide, user }: AdjustWalletModalProps) => {
  const [mode, setMode] = useState<"add" | "deduct">("add");
  const [amount, setAmount] = useState("500");
  const [type, setType] = useState("Goodwill");
  const [note, setNote] = useState("");

  useEffect(() => {
    if (show) { setMode("add"); setAmount("500"); setType("Goodwill"); setNote(""); }
  }, [show]);

  const apply = () => {
    const amt = Number(amount.replace(/,/g, ""));
    if (!amt || amt <= 0) return toast.warning("Enter an amount greater than 0");
    toast.info(`Wallet ${mode === "add" ? "credit" : "debit"} of ₹${amt.toLocaleString("en-IN")} · demo only, not saved`);
    onHide();
  };

  const balance = Number(user?.user_wallet_balance || 0);

  return (
    <Modal show={show} onHide={onHide} centered contentClassName="cx">
      <ActionModalHeader icon="ri-coins-line" title="Adjust wallet" subtitle={`${customerName(user)} · balance ₹${balance.toLocaleString("en-IN", { maximumFractionDigits: 2 })}`} onClose={onHide} />
      <div style={{ padding: "14px 20px" }}>
        <div className="cx-seg" style={{ marginBottom: 12 }}>
          <button type="button" className={mode === "add" ? "on" : ""} onClick={() => setMode("add")}>Add credit</button>
          <button type="button" className={mode === "deduct" ? "on" : ""} onClick={() => setMode("deduct")}>Deduct</button>
        </div>
        <div className="cx-fgrid">
          <div>
            <label className="cx-label">Amount (₹)</label>
            <input className="cx-input mono" inputMode="decimal" value={amount} onChange={(e) => setAmount(e.target.value)} />
          </div>
          <div>
            <label className="cx-label">Type</label>
            <select className="cx-select" value={type} onChange={(e) => setType(e.target.value)}>
              {["Goodwill", "Offline payment", "Refund", "Correction"].map(t => <option key={t}>{t}</option>)}
            </select>
          </div>
          <div className="full">
            <label className="cx-label">Note / reference</label>
            <input className="cx-input" placeholder="Ticket id, UTR no…" value={note} onChange={(e) => setNote(e.target.value)} />
          </div>
        </div>
        <p className="cx-help"><b>Offline payment</b> credits generate a GST tax invoice; other types are ledger adjustments only.</p>
        <DemoNote />
      </div>
      <div style={{ padding: "0 20px 18px", display: "flex", justifyContent: "flex-end", gap: 8 }}>
        <button type="button" className="cx-btn cx-btn-light" onClick={onHide}>Cancel</button>
        <button type="button" className="cx-btn cx-btn-primary" onClick={apply}>Apply</button>
      </div>
    </Modal>
  );
};

export default AdjustWalletModal;
